<div [formGroup]="form">
  <div class="method-container">
    <np-inv-type-radio-group [formControlName]="'PaymentMethod'"
                             [types]="types"
                             [disabled]="disableRadio$ | async"
                             class="delivery-payment-radio-group">
    </np-inv-type-radio-group>

    <app-custom-tooltip class="custom-tooltip">
      <ng-container tooltip-trigger>
        <i class="material-icons icon-help material-tooltip__btn cursor-pointer control-icons control-icons_help">help_outline</i>
      </ng-container>
      <ng-container tooltip-content>
        <div class="material-tooltip__content visible">Безготівковий розрахунок для відправника або отримувача доступний
                                                       лише
                                                       за умови підписання договору.
          <a href="https://novaposhta.ua/payment_korp_clients " target="_blank">Детальніше про послугу</a>
        </div>
      </ng-container>
    </app-custom-tooltip>
  </div>
</div>
